import axios from 'axios'
import moment from 'moment'
import MUIDataTable from 'mui-datatables'
import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'
import ContentWrapper from '../../Layout/ContentWrapper'

class Permissions extends React.Component {
  constructor() {
    super()
    this.state = {
      data: []
    }
  }

  componentDidMount() {
    this.axiosCancelSource = axios.CancelToken.source()
    axios
      .get('permissions', { cancelToken: this.axiosCancelSource.token })
      .then((res) => {
        console.log('Permissions response:', res.data)
        if (res.data.success) {
          const data = Array.isArray(res.data.data) ? res.data.data : []
          console.log('Setting permissions data:', data)
          this.setState({ data })
        } else {
          console.error('API returned success: false', res.data)
          this.setState({ data: [] })
        }
      })
      .catch((error) => {
        console.error('Error fetching permissions:', error)
        console.error('Error details:', error.response?.data || error.message)
        this.setState({ data: [] })
      })
  }

  componentWillUnmount() {
    if (this.axiosCancelSource) {
      this.axiosCancelSource.cancel('Component unmounted')
    }
  }

  render() {
    const columns = [
      {
        name: 'key',
        label: 'Key',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'allowedIds',
        label: 'Allowed IDs',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            const rowData = this.state.data[tableMeta.rowIndex]
            if (!rowData.populatedIds || rowData.populatedIds.length === 0) {
              return value && value.length > 0 ? `${value.length} ID(s)` : 'Të gjithë'
            }
            return (
              <div style={{ maxWidth: '300px' }}>
                {rowData.populatedIds.map((item, idx) => (
                  <span
                    key={idx}
                    className={`badge badge-${item.type === 'user' ? 'primary' : item.type === 'department' ? 'success' : item.type === 'project' ? 'info' : 'warning'} mr-1 mb-1`}
                    style={{ fontSize: '11px', display: 'inline-block' }}
                    title={item.email || item.name}
                  >
                    {item.type === 'user' ? '👤' : item.type === 'department' ? '🏢' : item.type === 'project' ? '📁' : '⚙️'} {item.name}
                  </span>
                ))}
              </div>
            )
          }
        }
      },
      {
        name: 'allowedIps',
        label: 'Allowed IPs',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            if (!value || value.length === 0) return 'Të gjithë'
            return (
              <div style={{ maxWidth: '300px' }}>
                {value.map((ip, idx) => (
                  <span
                    key={idx}
                    className='badge badge-info mr-1 mb-1'
                    style={{ fontSize: '11px', display: 'inline-block' }}
                  >
                    {ip}
                  </span>
                ))}
              </div>
            )
          }
        }
      },
      {
        name: 'allowedUserLevels',
        label: 'User Levels',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            return value && value.length > 0 ? value.join(', ') : 'Të gjithë'
          }
        }
      },
      {
        name: 'createdAt',
        label: 'Data e Krijimit',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value ? moment(value).format('DD/MM/YYYY HH:mm') : '-'
          }
        }
      },
      {
        name: 'updatedAt',
        label: 'Data e Modifikimit',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value ? moment(value).format('DD/MM/YYYY HH:mm') : '-'
          }
        }
      },
      {
        name: 'actions',
        label: 'Veprime',
        options: {
          filter: false,
          sort: false
        }
      }
    ]

    const options = {
      responsive: 'scroll',
      filterType: 'dropdown',
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: 'Nuk ka të dhëna'
        }
      }
    }

    const data = this.state.data.map((elem, index) => {
      return [
        elem.key || '-',
        elem.allowedIds || [],
        elem.allowedIps || [],
        elem.allowedUserLevels || [],
        elem.createdAt,
        elem.updatedAt,
        <Link key={index} to={`/editPermission/${elem._id}`}>
          <Button outline className='mb-1' color='warning' type='button'>
            <span>Modifiko</span>
          </Button>
        </Link>
      ]
    })

    return (
      <ContentWrapper>
        <div className='content-heading'>
          <div>Qasjet (Permissions)</div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              alignItems: 'flex-end'
            }}
            className='ml-auto'
          >
            <Link to='/editPermission/'>
              <Button color='success' className='btn-oval'>
                Shto qasje të re
              </Button>
            </Link>
          </div>
        </div>
        <Row>
          <Col>
            <MUIDataTable
              title={'Qasjet (Permissions)'}
              columns={columns}
              options={options}
              data={data}
            />
          </Col>
        </Row>
      </ContentWrapper>
    )
  }
}

export default Permissions
